<template>
  <div class="vm-pagination">
    <el-pagination background layout="prev, pager, next, sizes" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum" :page-size="queryInfo.pageSize"
      :page-sizes="[10, 50, 100]" :total="queryInfo.total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  name: 'vm-pagination',
  props: ['queryInfo'],
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    handleSizeChange (val) {
      this.queryInfo.pageSize = val
      this.queryInfo.pageNum = 1 // 切换每页条数时重置到第一页
      this.$emit('changePage', this.queryInfo)
    },
    handleCurrentChange (val) {
      this.queryInfo.pageNum = val
      this.$emit('changePage', this.queryInfo)
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.vm-pagination {
  width: 100%;
  box-sizing: border-box;
  padding: 15px 0;
  display: flex;
  justify-content: center;

  @{deep}.el-pagination {
    .el-pager {
      li {
        background: #fff;
        min-width: 35px;
        height: 35px;
        line-height: 35px;
        border-radius: 3px;
        border: 1px solid #e4e4e4;
      }

      .active {
        background-color: #666666 !important;
        color: #fff;
      }
    }

    button {
      line-height: 35px;
      height: 35px;
    }

    .el-input--mini .el-input__inner,
    .el-pagination__jump {
      height: 35px;
      line-height: 35px;
    }
  }
}
</style>
